
import {MdReportGmailerrorred} from "react-icons/md";
import {useLocation, useNavigate} from "react-router-dom";
import Button from "../components/Button";

const AccessDenied = () => {
    const {state}=useLocation();
    const navigate=useNavigate();
    const handleNavigate=()=>{
        if(state?.url){
            navigate(state?.url)
        }
    }
    return <div className="w-full flex  min-h-screen flex-col  items-center justify-center">
        <MdReportGmailerrorred className="text-6xl text-red-500 "/>
        <div className="w-11/12 flex justify-center items-center flex-col lg:w-4/12">
            <h1 className="text-2xl mt-4 text-red-500 font-bold">{state?.title||'خطای دسترسی'}</h1>
            <p className="text-sm mt-5 ">{state?.description||'دسترسی شما منقضی شده است '}</p>
            {state?.url && <Button theme="red" onClick={handleNavigate} rounded="rounded-xl" className="mt-5 text-sm" outlined >گرفتن دسترسی</Button>}
        </div>
    </div>
}
export default AccessDenied;